export const unwrapOneShotQuery = (request) => {
	const release = () => {
		if (typeof request?.unsubscribe === 'function') {
			request.unsubscribe();
		}
	};

	return request.unwrap().then(
		(value) => {
			release();
			return value;
		},
		(error) => {
			release();
			throw error;
		},
	);
};

export default unwrapOneShotQuery;
